import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class PostalCodeDataService {
    private postalCodes = new Map<string , HttpResponse<any>>();

    addPostalCodes(apiLink: string, res: HttpResponse<any>){
        if(apiLink != ''){
            this.postalCodes.set(apiLink,res);
        }
    }

    getPostalCodes(apiLink: string): HttpResponse<any> | undefined {
        return this.postalCodes.get(apiLink);
    }

    genratePostalCodeKey(countryCode,postalCode){
        return `POST_CODE_EXP_${countryCode}_${postalCode}`;
    }
    
    constructor() { }
}